import ExecutionEnv from 'exenv';
import { Component } from 'react';
import PropTypes from 'prop-types';
import withSideEffect from 'react-side-effect';

import { ensureNoClass } from 'helpers';
import { BODY_PAGE_CLASS } from 'common/regex';

/**
 * Meta-component that can show/hide header and footer content based on the properties passed in.
 *
 * See also: SiteAwareMetadata and react-side-effect.
 * @type {Object}
 */
export class DecoratedPage extends Component {
  static globalFootClass;
  static globalHeadClass;
  static globalPageClass;

  componentWillUnmount() {
    removeAllModifierClasses();
  }

  render() {
    return this.props.children;
  }
}

DecoratedPage.defaultProps = {
  hideHeader: false,
  hideFooter: false
};

DecoratedPage.propTypes = {
  hideHeader: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  hideFooter: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};

export function reducePropsToState(propsList) {
  return Object.assign({},...propsList);
}

export function removeAllModifierClasses({ body } = document) {
  DecoratedPage.globalHeadClass && ensureNoClass(body, DecoratedPage.globalHeadClass);
  DecoratedPage.globalFootClass && ensureNoClass(body, DecoratedPage.globalFootClass);
  DecoratedPage.globalPageClass && ensureNoClass(body, DecoratedPage.globalPageClass);
}

export function handleStateChangeOnClient(state, { body } = document, ChangeEvent = CustomEvent) {
  const match = BODY_PAGE_CLASS.exec(body.className);
  const bodyClass = body.classList;
  const pageClass = `page-${state.bodyPageClass}`;

  if (state.bodyPageClass && state.bodyPageClass.length) {
    // remove and then re-add if it is a new class
    if (match && match[0] !== pageClass) {
      bodyClass.remove(match[0]);
      bodyClass.add(pageClass);
      DecoratedPage.globalPageClass = pageClass;
    }

    if (!match) {
      bodyClass.add(pageClass);
      DecoratedPage.globalPageClass = pageClass;
    }
  } else {
    if (match) {
      bodyClass.remove(match[0]);
    }
  }

  const headClass = state.hideHeader === 'MOBILE' ? 'hideMobileHeader' : 'hideHeader';

  if (state.hideHeader) {
    bodyClass.add(headClass);
    DecoratedPage.globalHeadClass = headClass;
  } else {
    if (bodyClass.contains(headClass)) {
      bodyClass.remove(headClass);

      // fire event to have header recalculate "shyguy" menu size so the position correctly.
      const event = new ChangeEvent('locationchange');
      body.dispatchEvent(event);
    }
  }

  const footClass = state.hideFooter === 'MOBILE' ? 'hideMobileFooter' : 'hideFooter';
  if (state.hideFooter) {
    bodyClass.add(footClass);
    DecoratedPage.globalFootClass = footClass;
  } else {
    ensureNoClass(body, footClass);
  }
}

export default ExecutionEnv.canUseDOM ? withSideEffect(
  reducePropsToState,
  handleStateChangeOnClient
)(DecoratedPage) : ({ children }) => children;

